import { z } from 'zod';

/** One registered BYO Zemax bridge (in-process registry snapshot). */
export const ZemaxBridgeSchema = z.object({
  userEmail: z.string(),
  /** Epoch ms of the register call. */
  registeredAt: z.number(),
  /** Whether the bridge tab's SSE stream is currently attached. */
  streamAttached: z.boolean(),
  /** Requests dispatched to the bridge and not yet answered, oldest first. */
  inFlight: z.array(z.object({
    /** Worker endpoint path, e.g. "/run-script". */
    endpoint: z.string(),
    /** Epoch ms when the request was dispatched. */
    startedAt: z.number(),
    /** Server-computed age at snapshot time (immune to viewer clock skew). */
    elapsedMs: z.number(),
  })),
});
export type ZemaxBridge = z.infer<typeof ZemaxBridgeSchema>;

export const ZemaxBridgeListSchema = z.object({
  bridges: z.array(ZemaxBridgeSchema),
});
export type ZemaxBridgeList = z.infer<typeof ZemaxBridgeListSchema>;
